export const imagesForPortfolio = [
  {
    id: 1,
    title: "KOK",
    class: "kok",
    link: "kok",
  },

  {
    id: 2,
    title: "New Movements",
    class: "newMovements",
    link: "new-movements",
  },
  {
    id: 3,
    title: "Ambijus",
    class: "ambijus",
    link: "ambijus",
  },
  {
    id: 4,
    title: "Wilder Kitchen",
    class: "wilderKitchen",
    link: "wilder-kitchen",
  },
  {
    id: 5,
    title: "Vinbaren på Mølla",
    class: "winebarMolla",
    link: "vinbaren-pa-molla",
  },
  {
    id: 6,
    title: "Cliff Cabin",
    class: "cliffCabin",
    link: "cliff-cabin",
  },
  {
    id: 7,
    title: "Torungen design",
    class: "torungenDesign",
    link: "torungen-design",
  },
  {
    id: 8,
    title: "Bergill",
    class: "bergill",
    link: "bergill",
  },
  {
    id: 9,
    title: "Sovesveis",
    class: "sovesveis",
    link: "sovesveis",
  },
];
